


import React, { useState } from 'react';
import styles from  './EnquiriesAndAdmissions.module.css';

import HeadingAndIcon from '../../components/HeadingAndIcon/HeadingAndIcon';
import TabSelector from '../../components/TabSelector/TabSelector';
import NumberAndData from '../../components/NumberAndData/NumberAndData';
import { HiMiniDocumentText } from 'react-icons/hi2';

import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer
} from 'recharts';

const tabOptions = [{ label: 'Adm enquires' }, { label: 'Others' }];

const statData = [
  {
    number: 0,
    label: "Total Admission Enquires",
    backgroundVar: "rgba(from var(--Primary_Color) r g b / 0.7)",
  },
  {
    number: 0,
    label: "Unopened Enquiries",
    backgroundVar: "rgba(from var(--Warning_Color) r g b / 0.6)",
  },
  {
    number: 0,
    label: "Total Joined",
    backgroundVar: "rgba(from var(--Warning_Color) r g b / 0.3)",
  },
];

const chartData = [
  { name: 'May 1', total: 22, unopened: 10, joined: 15 },
  { name: 'May 2', total: 24, unopened: 18, joined: 17 },
  { name: 'May 3', total: 19, unopened: 9, joined: 13 },
  { name: 'May 4', total: 26, unopened: 15, joined: 16 },
  { name: 'May 5', total: 29, unopened: 18, joined: 11 },
  { name: 'May 6', total: 23, unopened: 11, joined: 19 },
  { name: 'May 7', total: 25, unopened: 16, joined: 13 },
];

export const EnquiriesAndAdmissions = () => {
  const [activeTab, setActiveTab] = useState(tabOptions[0].label);

  return (
    <div className={styles.container}>
      {/* Top Row */}
      <div className={styles.header}>
        <HeadingAndIcon
          heading="Enquires & Admissions"
          icon={<HiMiniDocumentText  color="var(--Primary_Color)" />}
        />
        <TabSelector options={tabOptions} setActiveTab={setActiveTab} activeTab={activeTab} />
      </div>

      {/* Stats Row */}
      <div className={styles.statsRow}>
        {statData.map((item, idx) => (
          <NumberAndData
            key={idx}
            number={item.number}
            label={item.label}
            backgroundVar={item.backgroundVar}
          />
        ))}
      </div>

      {/* Chart Section */}
      <div className={styles.chartContainer}>
        <ResponsiveContainer width="100%" height={250}>
          <AreaChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
            <defs>
              <linearGradient id="colorTotal" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#5f5fff" stopOpacity={0.4}/>
                <stop offset="95%" stopColor="#5f5fff" stopOpacity={0}/>
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Area type="monotone" dataKey="total" stroke="#5f5fff" fillOpacity={1} fill="url(#colorTotal)" />
            <Area type="monotone" dataKey="unopened" stroke="#6ab3a3" fillOpacity={0.1} fill="#6ab3a3" />
            <Area type="monotone" dataKey="joined" stroke="#f3c6c6" fillOpacity={0.1} fill="#f3c6c6" />
          </AreaChart>
        </ResponsiveContainer>
      </div>

      {/* Bottom Legends */}
      <div className={styles.legendRow}>
        <div><span style={{ backgroundColor: '#5f5fff' }} /> Total Enquires</div>
        <div><span style={{ backgroundColor: '#6ab3a3' }} /> Unopened Enquires</div>
        <div><span style={{ backgroundColor: '#f3c6c6' }} /> Joined total</div>
      </div>
    </div>
  );
};

export default EnquiriesAndAdmissions;

